import React from 'react'
import { FiltroCerealCerealVariedadYEtiquetaForm } from '../forms/filtroCerealCerealVariedadYEtiquetaForm'
export const FiltroCerealCerealVariedadYEtiquetaView = (props) =>
  <FiltroCerealCerealVariedadYEtiquetaForm
    etiquetas={props.etiquetas}
    onSubmit={props.submitFiltrosParaEmbarque}
  />
